<!-- src/views/HomePage.vue -->
<template>
     <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px;">
        <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
          <span>蓬勃发展的生态系统 </span>
          <h1>配件</h1> 
          <span class="c-mt-5 c-mb-5" style="text-align: left;"> 
            为了使系统能够立即在任何工业环境中安装和集成，我们致力于创建一个蓬勃发展的生态系统。通过内部开发、
            与第三方公司的合作以及兼容产品的精选，我们提供不断扩展的软件和硬件配件组合。
          </span>
        </div> 
        <div class="display-width c-text-both">
          <img src="@/assets/images/productsPage/Murrplastik_03-1.jpg" alt=""
            style="height: auto; max-width: 100%;"> 
        </div>
      </div> 
      
     <div id="product-add-ons"></div>
      <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">Franka Robotics 配件</span>
        <hr class="divider">
      </div> 
      <div class="c-text-between px-container  c-flex-wrap" style="margin-bottom: 120px;">
        <div class="module-width c-text-cocolumn " v-for="item in frankaList" :key="item.name" style="margin-bottom: 60px;">  
          <div class="c-mb-5 c-text-both" style="overflow: hidden;aspect-ratio: 716 / 716;">
            <img :src="item.url" alt=""  class="image-style" >
          </div>
          <div style="text-align: left;">   
            <span>{{item.title}}</span>
            <div class="c-text-align">
              <h1>{{item.name}}</h1>
                <span  v-show="item.name=='Franka GELLO'" class="c-ml-5 bg-chetwode-blue text-white rounded-full uppercase inline-flex items-center justify-center px-[8px] py-[3px] text-[8px] leading-[5px] lg:text-[10px] lg:leading-[8px] whitespace-nowrap">
              原型</span>
            </div> 
            <span class="c-mt-5 c-mb-5" > 
            {{item.content}}
            </span>
          </div>
          <div style="text-align: left;margin-top: 10px;"> 
            <a v-if="item.name=='Franka Hand'||item.name=='COBOT PUMP'" class="linkTag" @click="$router.push('/contact')">立即了解</a>
            <span v-if="item.name=='Franka Hand'||item.name=='COBOT PUMP'" style="margin: 0 10px;">l</span>
            <a  class="linkTag" @click="$router.push(item.infoUrl)">More information</a>
          </div>
        </div> 
      </div> 
      
      <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">集成配件</span>
        <hr class="divider">
      </div> 
      <div class="c-text-between px-container  c-flex-wrap" style="margin-bottom: 120px;">
        <div class="module-width c-text-cocolumn " v-for="item in accessoriesList" :key="item.name" style="margin-bottom: 60px;">  
          <div class="c-mb-5 c-text-both" style="overflow: hidden;aspect-ratio: 716 / 716;">
            <img :src="item.url" alt=""  class="image-style" >
          </div>
          <div style="text-align: left;">   
            <span>{{item.title}}</span>
            <h1>{{item.name}}</h1>
            <span class="c-mt-5 c-mb-5" > 
            {{item.content}}
            </span>
          </div>
          <div style="text-align: left;margin-top: 10px;">
             <a class="linkTag" @click="$router.push('/contact')">立即了解</a>
             <span v-if="item.title=='MURRPLASTIK'||item.title=='SCHMALZ'||item.title=='PICKNIK'" style="margin: 0 10px;">l</span>
              <a v-if="item.title=='SCHMALZ'" class="linkTag" href="https://vention.io/de/global-search#q=Franka%20&f-source=Community%20Designs" target="_blank">社区设计</a>
              <a v-if="item.title=='PICKNIK'" class="linkTag" href="https://docs.picknik.ai/hardware_guides/franka_fr3_hardware_setup_guide/" target="_blank">教程</a>
             <a v-if="item.title=='MURRPLASTIK'" class="linkTag" href="https://www.murrplastik.com/en/latest/article/cable-management-for-collaborative-robots-from-franka-robotics/" target="_blank">阅读文章</a>
          </div>
        </div> 
      </div> 
      
      <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">兼容配件</span>
        <hr class="divider">
      </div> 
      <div class="c-text-between px-container  c-flex-wrap" style="margin-bottom: 120px;">
        <div class="module-width c-text-cocolumn " v-for="item in otherList" :key="item.name" style="margin-bottom: 60px;">  
          <div class="c-mb-5 c-text-both" style="overflow: hidden;aspect-ratio: 716 / 716;">
            <img :src="item.url" alt=""  class="image-style" >
          </div>
          <div style="text-align: left;">   
            <span>{{item.title}}</span>
            <h1>{{item.name}}</h1>
            <span class="c-mt-5 c-mb-5" > 
            {{item.content}}
            </span>
          </div>
          <div style="text-align: left;margin-top: 10px;"> <a class="linkTag" @click="$router.push('/contact')">立即了解</a></div>
        </div> 
      </div> 
      <div class="c-text-column c-text-both action-height px-container" 
            style="align-items: flex-start; justify-content: center;">
            <h2 class="c-zIndex-2">有兴趣提升您机器人系统的能力吗？</h2>
            <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10 c-zIndex-2">
                <!-- <div class="buttonSite">  -->
                    <router-link  class="buttonSite">联系我们</router-link> 
                <!-- </div> -->
            </div>
            <div style="position: absolute;right: 0;height: 100%;"> 
              <img src="@/assets/images/productsPage/FR3 move new 6.png" alt=""
              style="    height: 100%; max-width: 100%;">
            </div> 
        </div> 
  </template>
  
  <script>
   
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'HomePage',
    data(){
      return{ 
        frankaList:[
          {
            title:'Franka Robotics',
            name:'Franka Hand',
            infoUrl:'/franka-hand',
            url:require('@/assets/images/accessories/Franka Hand.png'),
            content:'Franka Hand是由Franka Robotics生产的全电气化双指并行夹持器，完全集成设计，无需外部电缆。手爪的通信和电力供应通过机械臂的法兰连接器进行。'
          },
          {
            title:'FRANKA ROBOTICS / SCHMALZ',
            name:'COBOT PUMP',
            infoUrl:'/cobot-pump',
            url:require('@/assets/images/accessories/schmalz-cobot-pump.6e03d1c.png'),
            content:'Schmalz Cobot Pump是与Schmalz合作开发的末端执行器，完全集成于Franka Robotics的机器人系统中。它是一种智能电气真空发生器，用于处理气密性和轻微多孔的工件。'
          }, 
          {
            title:'FRANKA ROBOTICS',
            name:'FRANKA GELLO DUO',
            infoUrl:'/product-prototypes#prototypes',
            url:require('@/assets/images/accessories/Gello_resized.png'),
            content:'Franka GELLO Duo 是 Franka 对原始版本进行改进后的版本，其运动学设计模仿了 FR3 Duo。它作为一个双输入设备，用于直接（关节级直接控制）远程操作 FR3 Duo。研究人员可以借此探索双臂远程操作、模仿学习以及高级的双臂交互，为教授复杂技能提供了一种自然的方式。Franka GELLO Duo 的硬件和软件均已开源，免费提供给社区使用。'
          },
          {
            title:'Franka Robotics',
            name:'Franka GELLO',
            infoUrl:'/gello',
            url:require('@/assets/images/accessories/Design ohne Titel (22).jpg'),
            content:'Franka GELLO 是一款面向 FR3 的遥操作设备，能够实现直接的关节级遥操作，用于机器人示教、数据采集和模仿学习工作流。Franka GELLO 的硬件和软件均已开源，并免费向社区开放。'
          },
        ],
        
        accessoriesList:[
          {
            title:'工具快换装置',
            name:'MATCH',
            url:require('@/assets/images/accessories/match-hardware.c0a6be6.png'),
            content:'MATCH是Zimmer Group和Schmalz推出的新型多功能末端执行平台。它支持在不同的真空夹持器和机械夹持器之间进行切换，可以通过人体工学设计的单手点击系统手动操作，也可实现自动切换。'
          },
          {
            title:'ROBOCEPTION',
            name:'RC_VISCARD',
            url:require('@/assets/images/accessories/roboception-camera.5a3cabc.png'),
            content:'rc_visard 传感器系列使机器人能够实时生成并处理时间和位置相关数据。这种即插即用的机器视觉解决方案旨在为机器人应用实现真正的灵活性。'
          },
          {
            title:'MURRPLASTIK',
            name:'线缆管理系统',
            url:require('@/assets/images/accessories/Murrplastik 12 white BG_resized.png'),
            content:'murrplastik 专为 Franka Robotics 的机器人开发了定制化的线缆管理解决方案。有多种经过优化适配的个性化套装可供选择。它们使线缆管理更加简便，并在所有运动过程中保护线缆和机器人。'
          },
          {
            title:'SCHMALZ',
            name:'ECBPMi MATCH',
            url:'https://franka.de/hubfs/schmalz-ecbpmi-match.2e03c40.png',
            content:'Schmalz 的 ECBPMi MATCH 是一款专为 Ecosystem MATCH 设计的电动真空发生器，可实现与 Franka 机器人的即插即用集成。它提供快速工具更换、直观操作以及对中小型密闭工件的灵活处理能力。 '
          },
          {
            title:'ZIMMER GROUP',
            name:'LWR50L-03',
            url:require('@/assets/images/accessories/zimmer-gripper.76d2d83.png'),
            content:'Zimmer LWR50L-03 是一款专为 Ecosystem MATCH 设计的轻量化电动平行抓手，可与 Franka Emika 机器人完美兼容。它能够实现对小型零部件的精确、可靠处理，并具备快速工具更换和易于集成的特点。'
          },   
          {
            title:'HAPTION',
            name:'VIRTUOSE',
            url:require('@/assets/images/accessories/Kopie von Unbenannt (1) (1).jpg'),
            content:'Haption Virtuose 能够在远程环境中实现与机器人的真实力反馈交互。它与 Franka Research 3 集成，允许以 6 个自由度对末端执行器进行直观且物理逼真的控制。'
          },
          {
            title:'VENTION',
            name:'MACHINE BUILDER',
            url:require('@/assets/images/accessories/Screenshot Vention.png'),
            content:'Vention 的 MachineBuilder 是一个基于浏览器的 3D 设计平台，允许用户快速创建自定义的机器人工作单元和自动化设置。凭借其直观的拖拽式界面，它能够将 Franka 机器人无缝集成到模块化环境中，且无需任何 CAD 经验。'
          },
          {
            title:'PICKNIK',
            name:'MOVEIT PRO',
            url:require('@/assets/images/accessories/PickNik_RESIZED.png'),
            content:'MoveIt Pro 能够利用可用于生产环境的人工智能，来开发先进的操作类应用程序。它专为工业和研究应用而设计，为 Franka 机械臂的规划、控制、机器学习和仿真提供尖端能力。'
          },
          {
            title:'BOTA SYSTEMS',
            name:'夹爪延长线缆',
            url:require('@/assets/images/accessories/Franka Gripper Extension Cable_resized.png'),
            content:'来自 Bota Systems 的 Franka 夹爪延长线缆为 Franka 机器人与 Franka Hand 夹爪之间提供额外的线缆长度，确保可靠的电源和信号传输。如果在机器人法兰和 Franka Hand 之间安装了其他组件，可能需要此解决方案。'
          },
           
        ],
        
        otherList:[
          {
            title:'BOTA SYSTEMS',
            name:'SENSONE KIT',
            url:require('@/assets/images/accessories/Design ohne Titel (22).png'),
            content:'Bota Systems 的 SensONE 是一款紧凑型一体式六轴力-扭矩传感器，可安装在机器人法兰处。这种即插即用的解决方案可为要求严苛的应用提供高精度的力反馈，并与 Franka Hand 及其他配件兼容。注意：需要外部线缆连接。'
          }
           
        ] 
      }
    }
  };
  </script>
<style scoped> 

.action-height{
  height: 400px;
  background-color: #d5dbdc; 
  position: relative;
}
.module-width{
  width: calc(33% - 40px);
}
/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 1029px) {
  .module-width{
    width: calc(50% - 40px);
  }
  .action-height{
    height: 200px;
    background-color: #d5dbdc;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .module-width{
    width: calc(100% - 40px);
  }
} 

</style>
  